<div class="bg-gradient-login min-h-screen flex items-center justify-center">
  <div class="bg-white w-3/4 md:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center">
    <img src="assets/images/emblem.png" class="w-20" alt="">
    <span class="text-black text-xl font-bold mt-5 mb-2">Check your Email</span>
    <p class="text-gray-dark text-center">We have sent password reset instructions</p>
    <div class="w-full mt-3">
      <div class="w-full mb-3">
        <button routerLink="/login" class="w-full" mat-raised-button color="primary">{{ 'Back To Log In' | concat | translate }}</button>
      </div>
    </div>
  </div>
</div>